(()=>{'use strict';
function initialize(){
 const page=document.querySelector('[data-koll-product]')||document;
 const select=page.querySelector('#koll-product-form [name="id"]');
 for(const section of page.querySelectorAll('[data-koll-assembly-profile]')){
  if(section.dataset.assemblyBound==='true')continue;
  section.dataset.assemblyBound='true';
  const panels=[...section.querySelectorAll('[data-assembly-variant]')];
  function sync(){
   const selected=String(select?.value||section.dataset.selectedVariant||'');
   let visible=false;
   for(const panel of panels){
    const applicable=panel.dataset.assemblyVariant===selected;
    panel.hidden=!applicable;
    if(applicable)visible=true;
   }
   section.hidden=!visible;
  }
  let queued=false;
  function schedule(){
   if(queued)return;
   queued=true;
   requestAnimationFrame(()=>{queued=false;sync();});
  }
  select?.addEventListener('change',schedule);
  document.addEventListener('koll:variant-change',schedule);
  window.addEventListener('pageshow',sync);
  sync();
 }
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize,{once:true});
else initialize();
})();
